import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useServices, useStores } from 'index';

export const useGetAdminTrackmanEventsList = () => {
  const trackmanEventsEditorService = useServices().trackmanEventsEditorService;
  return useQuery({
    queryKey: ['adminTrackmanEventsList'],
    queryFn: trackmanEventsEditorService.getEvents,
    refetchOnWindowFocus: false,
  });
};

export const useGetAdminTrackmanEvent = (eventId: string | undefined) => {
  const trackmanEventsEditorService = useServices().trackmanEventsEditorService;
  return useQuery({
    queryKey: ['adminTrackmanEvent', eventId],
    queryFn: () => trackmanEventsEditorService.getEvent(eventId!),
    enabled: !!eventId,
    refetchOnWindowFocus: false,
  });
};

export const useDeleteAdminTrackmanEvent = () => {
  const trackmanEventsEditorService = useServices().trackmanEventsEditorService;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: (id: string) => trackmanEventsEditorService.deleteEvent(id),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['adminTrackmanEventsList'] }),
        queryClient.invalidateQueries({ queryKey: ['trackmanEventsList'] }),
      ]);
      notificationsStore.addToast('success', 'Event deleted successfully', 'success');
    },
  });
};
